/**
 * Index
 */

import Checkbox from './Inputs/Checkbox';
import Radio from './Inputs/Radio';
import Select from './Inputs/Select';
import Text from './Inputs/Text';
import Textarea from './Inputs/Textarea';
import Message from './Message';

export {
  Checkbox,
  Radio,
  Select,
  Text,
  Textarea,
  Message,
};

export default from './FormControl';
